




import { Vue, Component } from "vue-property-decorator";

import TicketSystem from "@share/ticketSystem/TicketSystem.vue";

@Component({ components: { TicketSystem } })

export default class TicketSystemView extends Vue {}

